module.exports = __webpack_public_path__ + "dfd25e896cf7e19989baf07c27e9a15e.png";